import { render, staticRenderFns } from "./treatment-step-two.html?vue&type=template&id=20e357a6&scoped=true&"
import script from "./treatment-step-two.js?vue&type=script&lang=js&"
export * from "./treatment-step-two.js?vue&type=script&lang=js&"
import style0 from "./treatment-step-two.scss?vue&type=style&index=0&id=20e357a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e357a6",
  null
  
)

export default component.exports